import * as general from './general'
import * as period from './period'

export const tariffHelper = {
  period,
  general,
}
